import { useTheme } from '@/components/ThemeProvider';
import { SortTypeEnum } from '@/request/request.enum';
import { SortIcon } from '@/widget/Icon';
import { useTranslation } from 'react-i18next';
import { SortConfig } from '../..';

interface IProps {
  handleSort: (key: SortConfig['key']) => void;
  getSortStatus: (key: SortConfig['key']) => SortTypeEnum;
}
export default (props: IProps) => {
  const { handleSort, getSortStatus } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <div className="flex items-center text-secondaryTextColor text-[12px] h-[32px] sticky top-0 left-0 right-0 bg-primaryBgColor z-10">
      <div className="flex-1">
        <div className="flex">
          <div className="flex items-center" onClick={() => handleSort('top10')}>
            <span>Top10</span>
            <SortIcon theme={theme} status={getSortStatus('top10')} className="w-[16px] h-[16px]" />/
          </div>
          <div className="flex items-center" onClick={() => handleSort('dev')}>
            <span>DEV</span>
            <SortIcon theme={theme} status={getSortStatus('dev')} className="w-[16px] h-[16px]" />
          </div>
        </div>
      </div>
      <div className="flex-[0.45]">
        <div className="flex items-center pr-0 justify-end" onClick={() => handleSort('progress')}>
          <span>{t('Token.status')}</span>
          <SortIcon theme={theme} status={getSortStatus('progress')} className="w-[16px] h-[16px]" />
        </div>
      </div>
      <div className="flex-[0.6]">
        <div className="flex justify-end">
          <div className="flex items-center" onClick={() => handleSort('volume')}>
            <span>{t('Token.vol')}</span>
            <SortIcon theme={theme} status={getSortStatus('volume')} className="w-[16px] h-[16px]" />/
          </div>
          <div className="flex items-center" onClick={() => handleSort('marketCap')}>
            <span>{t('Token.mc')}</span>
            <SortIcon theme={theme} status={getSortStatus('marketCap')} className="w-[16px] h-[16px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
